import styled from 'styled-components';

// Components
import { Modal, Typography } from 'top-component-library';

// Types
import { ModalProps } from 'antd';
import { WithReactChildren } from 'utils/Types';

const { Title } = Typography;

export const StyledModal: React.FunctionComponent<ModalProps & WithReactChildren> = styled(Modal)`
  &&& {
    background-color: var(--color-neutral__card-background);
    border-radius: var(--border-radius__regular);
    display: flex;
    flex-direction: column;
    padding-bottom: 0;

    max-width: 100%;
    width: 560px;

    .ant-modal-body {
      padding: 2rem;
    }
  }
`;

export const StyledTitle = styled(Title)`
  &&& {
    font-size: 1.5rem;
    margin-bottom: 2.5rem;
  }
`;
